var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "d-flex flex-column ga-6 border pa-6 rounded-sm" },
    [
      _c(_setup.BlockTitle, { attrs: { title: "СМИ о нас" } }),
      _vm._v(" "),
      _vm._l(_vm.news, function (newItem) {
        return _c("div", { key: newItem.id, staticClass: "d-flex ga-6" }, [
          _c("div", { staticClass: "news-item-info text-break" }, [
            _c("img", {
              staticClass: "mr-6 mb-4 rounded-sm",
              attrs: {
                src: newItem.publisher.logo.url,
                alt: "/",
                width: "200px",
                height: "auto",
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "text-body-2 text-secondary--text" }, [
              _vm._v("\n        " + _vm._s(newItem.link) + "\n      "),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(_setup.AdminButton, {
                attrs: {
                  text: "править",
                  link: _setup.reverseFull({
                    name: "admin:info_news_change",
                    args: [newItem.id],
                  }),
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "text-subtitle-1 text--text mb-2" }, [
                _vm._v("\n        " + _vm._s(newItem.header) + "\n      "),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-body-2 text-secondary--text mb-4" },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _setup.format(new Date(newItem.dt), "dd MMMM Y", {
                          locale: _setup.ru,
                        })
                      ) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "text-body-2 text-secondary--text" }, [
                _vm._v("\n        " + _vm._s(newItem.text) + "\n      "),
              ]),
            ],
            1
          ),
        ])
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }